import { MdOutlineDraw } from "react-icons/md";
import Button from "shared/components/Button";
import { find, get } from "lodash";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import Alert from "shared/components/Alert";

const Draft = ({ subscription, disabled, translation, signDocument }) => {
  const email = get(
    find(get(subscription, `project.contact.telecoms`, []), {
      system: CONTACT_POINT_SYSTEM.EMAIL,
    }),
    "value",
    "",
  );
  return (
    <>
      <Button
        type="secondary"
        alignment="center"
        loading={disabled}
        disabled={disabled || !email}
        onClick={() => signDocument()}
      >
        <MdOutlineDraw size={16} />
        {translation.E_SIGNATURE}
      </Button>
      {!email && (
        <div className="mt-16">
          <Alert
            type="warning"
            message={translation.E_SIGNATURE_EMAIL_REQUIRED}
          />
        </div>
      )}
    </>
  );
};

export default Draft;
